// react-data-table-component hands column options (right, allowOverflow, grow) to its
// styled cells, and styled-components v6 forwards unknown props to the DOM, where React
// warns about them. Filter them out; wrap any react-data-table-component table in
// <StyleSheetManager shouldForwardProp={forwardDataTableProp}>.
//
// Kept here rather than in components/DataTable.js so pages that use the library directly
// (the public statement page) don't pull that whole module into their bundle.
export const forwardDataTableProp = (prop) => !['right', 'allowOverflow', 'grow'].includes(prop);
